import { inject as d, ref as a, onMounted as m, onBeforeUnmount as v } from "vue";
import { internalSelectionMenuBodyInjectionKey as s } from "./ghl-ui.es1467.js";
import { modalBodyInjectionKey as p } from "./ghl-ui.es1019.js";
import { drawerBodyInjectionKey as y } from "./ghl-ui.es954.js";
import { popoverBodyInjectionKey as j } from "./ghl-ui.es1313.js";
import { on as B, off as b } from "./ghl-ui.es694.js";
import _ from "./ghl-ui.es690.js";
const i = "__disabled__";
function f(c) {
  const o = d(p, null), l = d(y, null), u = d(j, null), t = d(s, null), r = a();
  if (typeof document < "u") {
    r.value = document.fullscreenElement;
    const n = () => {
      r.value = document.fullscreenElement;
    };
    m(() => {
      B("fullscreenchange", document, n);
    }), v(() => {
      b("fullscreenchange", document, n);
    });
  }
  return _(() => {
    var n;
    const {
      to: e
    } = c;
    return e !== void 0 ? e === !1 ? i : e === !0 ? r.value || "body" : e : o != null && o.value ? (n = o.value.$el) !== null && n !== void 0 ? n : o.value : l != null && l.value ? l.value : u != null && u.value ? u.value : t != null && t.value ? t.value : e ?? (r.value || "body");
  });
}
f.tdkey = i;
f.propTo = {
  type: [String, Object, Boolean],
  default: void 0
};
export {
  f as useAdjustedTo
};
